module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_300_Regular.d4d09e6.woff2";